<template>
  <div v-if='isGrid' class='properties-listing'>
    <div class='default-content'>
      <div v-if='searchprofiles && searchprofiles.length' class='properties-listing__area' :class="{ 'list-view': isList }">
        <div class='properties-item' v-for='searchprofile in searchprofiles'>
          <div class='properties-item__info'>
            <div class='properties-item__heading'>
              <div class='properties-item__title'>
                <div class='properties-item__name'>
                  {{ locales && locales.searches && locales.searches.search_message }} {{searchprofile.location || ''}} (+{{searchprofile.distance || 0}}km).
                  {{ locales && locales.searches && locales.searches.please_contact_us }}
                </div>
              </div>
              <div class='properties-item__price'>
                <span class='properties-item__price-value'>
                  {{locales.searches && locales.searches.max_people}} 
                  {{ (searchprofile.number_of_women + searchprofile.number_of_men) }}
                </span>
              </div>
            </div>
            <div class='properties-item__bottom'>
              <div class='properties-item__parameters'>
                <div class='properties-item__parameters-item'>
                  <i class='icon-bed'></i>
                  {{ searchprofile.min_number_of_bedrooms || 0 }}
                </div>
              </div>
              <button class="theme-btn theme-btn--small theme-btn--theme" data-feature="open-modal" data-target="require-login" v-if="websiteId !== 2 && mustLogin">{{locales && locales.common && locales.common.contact_us}}</button>
              <button class="theme-btn theme-btn--small theme-btn--theme" :id="'md'+searchprofile.subscription_id" data-feature="open-modal" data-target="ask-question" @click="showMessage(searchprofile.subscription_id, (searchprofile[1] ===1 ? 0 : searchprofile.id), searchprofile.location, searchprofile.distance)" v-else>{{locales && locales.common && locales.common.contact_us}}</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class='properties-listing__empty'>
        <div class='properties-listing__empty-icon-holder'>
          <i class='icon-home properties-listing__empty-icon'/>
        </div>
        <div class='properties-listing__empty-title'>{{locales.searches && locales.searches.no_searchprofiles}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import "tempusdominus-bootstrap-4";

  export default {
    computed: {
      ...mapGetters(['metadata', 'locales']),
      layout() {
        return this.$store.getters.getSearchprofilesLayout;
      },
      searchprofiles() {
        return this.$store.getters.getSearchprofilesCollection;
      },
      isGrid: function() {
        return this.$store.getters.getSearchprofilesIsGrid;
      },
      isList: function() {
        return this.$store.getters.getSearchprofilesIsList;
      },
    },
    props: {
      lang: {
        default: '',
        type: String,
      },
      websiteId: {
        default: 1,
        type: Number,
      },
      mustLogin: {
        default: false,
        type: Boolean,
      },
      site: {
        default: '',
        type: String,
      },
      booking: {
        default: 0,
        type: Number,
      },
    },
    methods: {
      resetFilters() {
        window.location.search = '';
      },
      showMessage(subsciption, searchprofile, location, distance) {
        var array = {
          'subscriptionId': subsciption,
          'searchprofileId': searchprofile,
          'sLocation': location,
          'distance': distance,
          'showRespondMessage': true,
        }
        this.$emit("update-form-variables", array);
      },
    }
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/SearchprofilesListing.vue